import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { ResetPwTemplate } from "components/entrance/signin";
import Toast from "components/ui/Toast";
// redux
import { fetchResetPassword } from "redux/slices/signin/signinSlice";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { phoneNumber } = useSelector((state) => state.signin);
  const [signinInfo, setSigninInfo] = useState({
    passCode: "",
    passCodeConfirm: "",
  });

  const handleChange = (e, name) => {
    setSigninInfo((previousValue) => ({
      ...previousValue,
      [name]: e.target.value,
    }));
  };

  const handleClickDone = () => {
    dispatch(fetchResetPassword({ ...signinInfo, phoneNumber }))
      .unwrap()
      .then((result) => {
        if (result) {
          Toast("비밀번호가 변경되었습니다", "key");
          navigate("/entrance/signin");
        }
      })
      .catch((e) => {});
  };

  return (
    <ResetPwTemplate
      title={`새로운 비밀번호를\n등록해주세요`}
      inputValue={signinInfo}
      inputValueChange={handleChange}
      buttonOnClick={handleClickDone}
    />
  );
};
export default ResetPassword;
